import { render, staticRenderFns } from "./faturaDetay.vue?vue&type=template&id=54872256&scoped=true&"
import script from "./faturaDetay.vue?vue&type=script&lang=js&"
export * from "./faturaDetay.vue?vue&type=script&lang=js&"
import style0 from "./faturaDetay.vue?vue&type=style&index=0&id=54872256&lang=scss&scoped=true&"
import style1 from "./faturaDetay.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54872256",
  null
  
)

export default component.exports